import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { idb, TOKO, penyimpananSiap } from './lib/idb';
import { setToken } from './lib/api';
import { dengarkan, mulaiMesin, type KeadaanAntrean } from './lib/outbox';

export interface Sesi {
  token: string;
  pengguna: { id: string; nama: string; peran: string };
  tenant: { id: string; nama: string; slug: string };
  outletId: string;
  outletNama: string;
  terminalId: string;
  terminalKode: string;
  shiftId?: string;
}

interface Konteks {
  sesi: Sesi | null;
  simpanSesi: (s: Sesi | null) => Promise<void>;
  antrean: KeadaanAntrean;
  penyimpananOk: boolean;
  siap: boolean;
}

const Ctx = createContext<Konteks | null>(null);
export const useSesi = () => {
  const c = useContext(Ctx);
  if (!c) throw new Error('useSesi harus di dalam Penyedia');
  return c;
};

export function Penyedia({ children }: { children: ReactNode }) {
  const [sesi, setSesi] = useState<Sesi | null>(null);
  const [siap, setSiap] = useState(false);
  const [penyimpananOk, setPenyimpananOk] = useState(true);
  const [antrean, setAntrean] = useState<KeadaanAntrean>({
    menunggu: 0, ditolak: 0, sedangKirim: false, tertuaMenit: 0, online: navigator.onLine,
  });

  useEffect(() => {
    (async () => {
      const ok = await penyimpananSiap();
      setPenyimpananOk(ok);

      // Sesi bertahan melintasi muat ulang. Tablet kasir di-restart di tengah
      // shift adalah kejadian biasa, bukan luar biasa — kasir tidak boleh
      // diminta masuk ulang di depan antrean.
      if (ok) {
        const tersimpan = await idb.get<Sesi>(TOKO.meta, 'sesi');
        if (tersimpan) { setToken(tersimpan.token); setSesi(tersimpan); }
      }
      setSiap(true);
      mulaiMesin();
    })();
    return dengarkan(setAntrean);
  }, []);

  const simpanSesi = async (s: Sesi | null) => {
    setSesi(s);
    setToken(s?.token ?? null);
    if (s) await idb.set(TOKO.meta, s, 'sesi');
    else await idb.del(TOKO.meta, 'sesi');
  };

  return (
    <Ctx.Provider value={{ sesi, simpanSesi, antrean, penyimpananOk, siap }}>
      {children}
    </Ctx.Provider>
  );
}
